<script setup lang="ts">
interface Props {
  useVideo?: boolean
}
const { useVideo } = defineProps<Props>()
const { cdn } = useRuntimeConfig().public
const mobileVideoUrl = computed(() => `${cdn}/static/banners/video-mobile.mp4`)
const desktopVideoUrl = computed(() => `${cdn}/static/banners/video-desktop.mp4`)

</script>

<template>
  <div class="relative">
    <div class="relative hidden xs:block">
      <div class="absolute top-0 left-0 w-full sm:w-3/5 h-full bg-[linear-gradient(#343A40,transparent_15%)]">
        <NuxtLink to="/k/oferta"
          class="absolute top-0 right-0 w-[calc(60vw-((100vw-1140px)/2))] max-w-full h-full p-[20px]">
         <!-- <h1 class="text-white">
           Jazda samochodami sportowymi
         </h1> -->
        </NuxtLink>
      </div>
      <template v-if="useVideo">
        <video autoplay loop muted playsinline>
          <source :src="mobileVideoUrl" type="video/mp4">
        </video>
      </template>
      <template v-else>
       <Img src="/mobile.jpg?t=1748327123" width="480" height="723" alt="Jazda samochodami sportowymi" loading="eager"
         class="flex justify-center" />
        <!-- <Img
          src="/banners/mobile.jpg?t=1748327284"
          width="480"
          height="723"
          alt="Jazda samochodami sportowymi"
          loading="eager"
          class="flex justify-center"
        /> -->
      </template>
    </div>
    <div class="hidden sm:flex justify-center">
      <div class="relative">
        <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-secondary to-15% to-transparent" />
        <template v-if="useVideo">
          <video autoplay loop muted playsinline>
            <source :src="desktopVideoUrl" type="video/mp4">
          </video>
        </template>
        <template v-else>
         <Img src="/desktop.jpg?t=1748327123" width="1920" height="550" alt="Jazda samochodami sportowymi"
           class="flex justify-center" />
           <!-- <Img src="/banners/desktop.jpg?t=1748327284" width="1920" height="550" alt="Jazda samochodami sportowymi" class="flex justify-center" /> -->
        </template>
      </div>
      <div class="absolute top-0 left-0 w-full sm:w-3/5 h-full">
        <NuxtLink to="/k/bestsellery"
          class="absolute top-0 right-0 w-[calc(60vw-((100vw-1140px)/2))] max-w-full h-full p-[20px]">
         <!-- <h1 class="text-white text-32">
           Jazda samochodami sportowymi
         </h1> -->
        </NuxtLink>
      </div>
    </div>
    <BannersMap />
  </div>
</template>
